import TiposDeCanaisEnum from '../../entities/canal/TiposDeCanaisEnum'
import SolicitanteModel from '../../entities/solicitante/SolicitanteModel'

export default class GetTicketByIdModel {
  constructor({
    id = 0,
    filaId = 0,
    filaPermiteAgendamento = false,
    atendenteId = 0,
    titulo = '',
    protocolo = '',
    tipoSolicitacaoId = 0,
    tipoSolicitacaoNome = '',
    statusId = 0,
    statusNome = '',
    categoriaStatusId = 0,
    canalId = 0,
    canalTipoId = 0,
    chatBotId = null,
    chatBotProvedorComunicacaoId = null,
    dataCadastro = '',
    dataUltimaAlteracao = '',
    dataUltimaMensagem = '',
    solicitante = new SolicitanteModel(),
  } = {}) {
    this.id = id
    this.filaId = filaId
    this.filaPermiteAgendamento = filaPermiteAgendamento
    this.atendenteId = atendenteId
    this.titulo = titulo
    this.protocolo = protocolo
    this.tipoSolicitacaoId = tipoSolicitacaoId
    this.tipoSolicitacaoNome = tipoSolicitacaoNome
    this.statusId = statusId
    this.statusNome = statusNome
    this.categoriaStatusId = categoriaStatusId
    this.canalId = canalId
    this.canalTipoId = canalTipoId
    this.chatBotId = chatBotId
    this.chatBotProvedorComunicacaoId = chatBotProvedorComunicacaoId
    this.dataCadastro = dataCadastro
    this.dataUltimaAlteracao = dataUltimaAlteracao
    this.dataUltimaMensagem = dataUltimaMensagem
    this.solicitante = solicitante
  }

  isTicketCanalBotOuWhatsApp() {
    return this.canalTipoId === TiposDeCanaisEnum.WhatsApp || this.canalTipoId === TiposDeCanaisEnum.Bot
  }
}
